import React from "react";

import ArticleSidebar from "~/components/ArticleSidebar";
import BlockList from "~/blocks/BlockList";
import Header from "~/components/PageHeader";

export const PageArticleSidebar = ({ data }) => {
    const { pageheaderOptions, ctaSections } = data.wpPage;

    return (
        <ArticleSidebar
            hideTwitter={pageheaderOptions?.hideTwitter}
            ctas={ctaSections?.sections || []}
        />
    );
};

export const PageBlockList = ({ data, breadcrumbs, urlPermutations }) => {
    const { blocks, translations, uri } = data.wpPage;

    return (
        <BlockList
            {...{
                blocks,
                translations,
                uri,
                urlPermutations,
                crumbs: breadcrumbs,
            }}
        />
    );
};

export const PageHeader = ({ data, breadcrumbs, urlPermutations }) => {
    const { pageheaderOptions, uri } = data.wpPage;

    return (
        <Header
            crumbs={breadcrumbs}
            {...pageheaderOptions}
            {...{ uri, urlPermutations }}
        />
    );
};
